module.exports = __webpack_public_path__ + "img/top.4bbc4e7d.jpg";